module.exports = __webpack_public_path__ + "static/RalewayBold-575e4317521b381ac94c0c8207c81979.ttf";